import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  Chip,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import api from "../../../services/api";

const UpsellTable = ({ items, onEdit }) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Triggers</TableCell>
            <TableCell>Max/Order</TableCell>
            <TableCell>Active</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {items.map((item) => (
            <TableRow key={item._id} hover>
              <TableCell>
                <Box display="flex" alignItems="center" gap={2}>
                  {item.image && (
                    <Box
                      component="img"
                      src={item.image}
                      alt={item.name}
                      sx={{ width: 40, height: 40, borderRadius: 1 }}
                    />
                  )}
                  <Box>
                    <Typography fontWeight={600}>
                      {item.displayName || item.name}
                    </Typography>
                    {item.originalPrice && (
                      <Typography variant="caption" color="text.secondary">
                        Originally ${item.originalPrice.toFixed(2)}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </TableCell>

              <TableCell>${item.price.toFixed(2)}</TableCell>

              <TableCell>
                <Box display="flex" flexDirection="column" gap={0.5}>
                  {item.trigger?.productTypes?.length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      Types:{" "}
                      {item.trigger.productTypes.map((type) => (
                        <Chip
                          key={type}
                          label={type}
                          size="small"
                          sx={{ mr: 0.5 }}
                        />
                      ))}
                    </Typography>
                  )}
                  {item.trigger?.productIds?.length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      Specific Products: {item.trigger.productIds.length}
                    </Typography>
                  )}
                  {item.trigger?.minSubtotal && (
                    <Typography variant="caption" color="text.secondary">
                      Min Subtotal: ${item.trigger.minSubtotal.toFixed(2)}
                    </Typography>
                  )}
                </Box>
              </TableCell>

              <TableCell>{item.maxPerOrder}</TableCell>

              <TableCell>
                <Chip
                  label={item.isActive ? "Active" : "Inactive"}
                  color={item.isActive ? "success" : "default"}
                  size="small"
                />
              </TableCell>

              <TableCell>
                <Tooltip title="Edit">
                  <IconButton onClick={() => onEdit(item)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UpsellTable;
